// @ts-nocheck
/* Store Custom Code - Start */
import { BaseModel, ImageModel } from "@insite/client-framework/Types/ApiModels";
import { AvailabilityMessageType } from "@insite/client-framework/Types/ApiModels";
import { StoreAccountApiParameter } from "@store/Framework/Services/StoreAccountService";

export interface StoreAccountModel extends StoreAccountApiParameter {}

export const ExtendedAvailabilityMessageType = {
    SpecialOrder: 4 as AvailabilityMessageType,
};

export interface OrderTransactionType {
    key: string;
    value: string;
}

export interface OrderTransactionTypeCollectionModel extends BaseModel {
    transactionTypes: OrderTransactionType[];
}

export interface ExtendedImageModel extends ImageModel {
    isVideo?: boolean;
    videoUrl?: string;
}

export interface ApplicationsCategoriesModel {
    shortDescription?: string;
    icon?: string;
    uri?: string;
}

export interface ImagePropertiesModel {
    id: string;
    properties: {
        isVideo?: string;
        url?: string;
    };
}
export interface InvoiceAddressModel {
    address1: string;
    address2?: string;
    address3?: string;
    city: string;
    companyName: string;
    country?: string;
    postalCode: string;
    state: string;
}

export interface InvoiceOtherChargeModel {
    amount: number;
    amountDisplay: string;
    description: string;
}

export interface InvoicePaymentSuccessModel {
    authorizationCode: string;
    amount: number;
}

export interface BillToModel {
    address1: string;
    address2?: string;
    address3?: string;
    city: string;
    companyName?: string;
    country?: string;
    postalCode: string;
    state?: string;
}

export interface ShipToModel {
    address1: string;
    address2?: string;
    address3?: string;
    city: string;
    companyName?: string;
    country: string;
    postalCode: string;
    state?: string;
}

export interface ThirdPartyScriptSettings {
    enableMicrosoftConversionTracking?: boolean;
    microsoftConversionTrackingId?: string;
}
/* Store Custom Code - End */
